import { createLogger } from '../../shared/logger'

export const CHILI_DEANON_DEBUG_KEY = 'chilideanon:debug'

const snippetLogger = createLogger('ChiliDeanonSnippet', CHILI_DEANON_DEBUG_KEY)

export const logger = snippetLogger
export const getMode = snippetLogger.getMode
